import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, Redirect } from 'react-router-dom';
import { GlobalContext } from '../../contexts/states/GlobalState';
import '../../styles/form_page.css';
import { GlobalErrorHandler } from '../Layouts/GlobalErrorHandler';
import { InnerLoading } from '../Layouts/InnerLoading';
import LoginFormSvg from '../svgs/LoginFormSvg';

export const LoginPage = () => {
  const { error, setError, loading, loginAdmin, globalError, done } =
    useContext(GlobalContext);

  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [iconName, setIconName] = useState('eye');
  const [formError, setFormError] = useState(false);
  const [passwordType, setPasswordType] = useState('password');

  const togglePasswordVisibility = () => {
    if (iconName === 'eye') {
      setIconName('eye-slash');
      setPasswordType('text');
    } else {
      setIconName('eye');
      setPasswordType('password');
    }
  };

  const verifyUserInput = (e) => {
    e.preventDefault();

    if (!password || !username) {
      return setFormError('All fields are required');
    }

    loginAdmin(username, password);
  };

  useEffect(() => {
    let t;
    if (formError) {
      t = setTimeout(() => {
        setFormError(false);
      }, 4000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [formError]);

  useEffect(() => {
    let t;
    if (error) {
      t = setTimeout(() => {
        setError(false);
      }, 4000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [error]);

  return (
    <div className='form-page-container'>
      {done && <Redirect push to={done} />}
      <Helmet>
        <title>Login | LionTaxi Admin</title>
      </Helmet>
      <div className='form-page-link'>
        <Link to='/admin/register'>Register</Link>
      </div>
      <div className='form-page-header'>
        <h3>
          <i className='fas fa-sign-in-alt'></i> Login
        </h3>
      </div>
      <div className='form-card-con'>
        <div className='form-svg'>
          <LoginFormSvg />
        </div>
        <div className='form-page-form'>
          <form onSubmit={verifyUserInput}>
            <label htmlFor='username'>Username</label>
            <input
              type='text'
              id='username'
              name='username'
              placeholder='e.g john_doe'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required={true}
            />
            <div className='password-con'>
              <label htmlFor='password'>Password</label>
              <input
                type={passwordType}
                name='password'
                id='password'
                placeholder='Enter password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required={true}
              />
              <div className='password-icon'>
                <i
                  className={`fas fa-${iconName}`}
                  onClick={togglePasswordVisibility}
                ></i>
              </div>
            </div>
            <button
              className='form-submit'
              onClick={verifyUserInput}
              disabled={loading}
            >
              {loading ? <InnerLoading color='#f5feffd4' /> : 'Log in'}
            </button>
            {formError && (
              <div className='form-error'>
                <p>{formError}</p>
              </div>
            )}
            {error && (
              <div className='form-error'>
                <p>{error}</p>
              </div>
            )}
          </form>
        </div>
      </div>
      <div className='connection-error-handler'>
        <div className={`modal-con ${globalError && 'active'}`}>
          {globalError && (
            <GlobalErrorHandler error={globalError} context={GlobalContext} />
          )}
        </div>
      </div>
    </div>
  );
};
